import React, { useState } from "react";
import axios from "axios";
import CloseIcon, { DarkCLoseIcon } from "assets/Icons/icons/CloseIcon";
import { useIsDarkTheme } from "helpers/darktheme";
import { set } from "react-hook-form";

const FeedbackForm = ({ onClose }) => {
    const [rating, setRating] = useState(null);
    const [feedback, setFeedback] = useState("");
    const [loading, setLoading] = useState(false);
    const isDarkTheme = useIsDarkTheme();

    const handleSubmit = async () => {
        if (!rating) {
            alert("Please select a rating before submitting.");
            return;
        }

        setLoading(true);
        const payload = {
            form: "feedback",
            rating,
            user_comments: feedback,
        };
        try {
            await axios.post(process.env.REACT_APP_FORM_URL, payload, {
                headers: {
                    "Content-Type": "application/json",
                },
            });
            alert("Feedback submitted successfully!");
            setFeedback("");
            setRating(null);
            onClose();
        } catch (error) {
            throw new Error("Error submitting feedback. Please try again.");
        }
        setLoading(false);
    };

    return (
        <div className="fixed inset-0 flex items-center justify-center bg-gray-900 bg-opacity-50">
            <div className="bg-white dark:bg-[#0D1822] rounded-lg shadow-lg w-[455px] text-[#454545] dark:text-white">
                <div className="flex justify-between items-center border-b border-[#D9D9D9] dark:border-[#424E59] py-4 px-6">
                    <h2 className="text-lg font-semibold">Give Feedback</h2>
                    <button
                        onClick={onClose}
                        className="border border-[#D9D9D9] dark:border-[#424E59] rounded-lg p-2"
                    >
                        {isDarkTheme ? <CloseIcon /> : <DarkCLoseIcon />}
                    </button>
                </div>

                <div className="p-6">
                    <h3 className="text-xl mb-1 text-[#262626] dark:text-white font-semibold">
                        Let us know your thoughts
                    </h3>
                    <p className="leading-6 text-[15px]">
                        How would you rate your experience with the plugin on a
                        scale of 1 (not satisfied at all) to 5 (highly
                        satisfied)?
                    </p>

                    <div className="flex justify-between mt-4 mb-2 border border-[#D9D9D9] dark:bg-[#424E59] dark:border-[#616B74] w-full">
                        {[1, 2, 3, 4, 5].map((num) => (
                            <button
                                key={num}
                                onClick={() => setRating(num)}
                                className={`px-6 py-[10px] w-full border-r border-[#D9D9D9] last:border-none text-base font-medium ${
                                    rating === num
                                        ? "bg-orange-500 text-white"
                                        : "text-[#262626] dark:text-white"
                                }`}
                            >
                                {num}
                            </button>
                        ))}
                    </div>

                    <div className="flex justify-between text-[13px] leading-4 text-[#595959] dark:text-white">
                        <span>Extremely Dissatisfied</span>
                        <span>Extremely Satisfied</span>
                    </div>

                    <div className="mt-6">
                        <label className="text-[15px] leading-6 font-medium">
                            Why did you give that rating?
                        </label>
                        <textarea
                            className="w-full mt-[6px] border border-[#D1D5DB] dark:border-[#616B74] rounded-lg p-2 focus:ring-2 focus:ring-orange-500 dark:bg-[#424E59]"
                            rows="4"
                            value={feedback}
                            onChange={(e) => setFeedback(e.target.value)}
                        ></textarea>
                    </div>
                </div>

                <div className="flex justify-end gap-[10px] mt-16 border-y border-[#F0F0F0] dark:border-[#424E59] py-3 pr-6 font-semibold text-sm">
                    <button
                        onClick={onClose}
                        className="px-3 py-2 border border-[#D9D9D9] dark:bg-[#424E59] dark:border-[#616B74] rounded-md text-[#595959] dark:text-white"
                    >
                        Cancel
                    </button>
                    <button
                        onClick={handleSubmit}
                        className="px-[18px] py-2 bg-[#E37915] border border-[#FFFFFF1F] text-white rounded-md hover:bg-orange-600"
                        disabled={loading}
                    >
                        {loading ? "Sending..." : "Send Feedback"}
                    </button>
                </div>

                <div className="bg- w-full text-center py-[18px] text-sm text-[#454545] dark:text-white">
                    For technical support, please visit{" "}
                    <span className="text-orange-500 underline pl-[6px]">
                        <a
                            href="https://alluvium-hq.atlassian.net/servicedesk/customer/portal/11"
                            target="_blank"
                        >
                            Support
                        </a>
                    </span>
                </div>
            </div>
        </div>
    );
};

export default FeedbackForm;
